import React from 'react';
import { Link, useLocation } from "react-router-dom";
import useGlobal from '../../../store';

const Menu = (props) => {

    let location = useLocation();

    const [state, uiActions] = useGlobal(
        state => state,
        actions => actions.uiActions
    );

    const openSidePanel = (panelName) => {
        let paramState = {
            selectedUser: state.user
        }
        if(location.pathname.indexOf("gift-list") >= 0 && state.activeGiftlist && state.activeGiftlist.user) {
            paramState.selectedUser = state.activeGiftlist.user;
        }
        uiActions.toggleSidePanel(panelName, paramState);
    }

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
          return <img className="avatar avatar-xs" src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
        }
        // if(userData.FBID && userData.FBID !== "0") {
        //   return <img className="avatar avatar-xs" src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
        // }
        return (<div className="kt-media kt-media--xs kt-media--circle kt-media--info">
            <span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>
        </div>);
    }

  return (
      <>
    <button className="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn"><i className="la la-close"></i></button>
<div className="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
	<div id="kt_header_menu" className="kt-header-menu kt-header-menu-mobile ">
        
		<ul className="kt-menu__nav ">
			<li className="kt-menu__item  kt-menu__item--open kt-menu__item--here kt-menu__item--submenu kt-menu__item--rel kt-menu__item--open kt-menu__item--here" >
                <Link to="/home" className="kt-menu__link kt-menu__toggle">
                {state.user ? buildAvatarUrl(state.user) : <></>}
                    <span className="ml-1 kt-menu__link-text">{state.user ? state.user.FirstName : "Me"}</span></Link>
			</li>

            <li className="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel" >
                <div onClick={() => openSidePanel("nicelist")} className="kt-menu__link kt-menu__toggle">
                    <span className="kt-menu__link-text">Gift Lists ({state.giftlists.length})</span></div>
			</li>

            <li className="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel" >
                <div onClick={() => openSidePanel("shoppinglist")} className="kt-menu__link kt-menu__toggle">
                    <span className="kt-menu__link-text">Shopping List ({state.shoppinglist.length})</span></div>
			</li>
		</ul>
	</div>
	<div className="kt-header-toolbar">
		<button onClick={() => openSidePanel("addgiftlist")} className="btn btn-bold mr-1 btn-danger btn-upper">
            <i className="flaticon2-plus-1"></i> Add List</button>
        <button onClick={() => openSidePanel("additem")} className="btn btn-bold btn-success btn-upper">
            <i className="flaticon2-plus-1"></i> Add Item</button>
	</div>
</div></>

  );
}

export default Menu;